import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";
import { LENDER_ANALYTIC_EVENTS } from "@/modules/contacts/features/lender/utils/lender-analytic-events";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { loanService } from "@/redux/services/loanService";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";
import { lenderBoardService } from "@/features/LenderBoard/Management/store/lenderBoardService";
import { LENDER_BOARD_SERVICE_TAG } from "@/features/LenderBoard/Management/utils/lender-board-service-tags";

const updateLender = lenderService.injectEndpoints({
  endpoints: builder => ({
    updateLender: builder.mutation({
      query: ({ lenderId: id, ...body }) => ({
        url: `lenders/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: LENDER_SERVICE_TAG, id },
        { type: LENDER_SERVICE_TAG, id: LIST_SERVICE_TAG },
      ],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(LENDER_ANALYTIC_EVENTS.LENDER_UPDATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Lender has been updated!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(loanService.util.invalidateTags(["LoanLendersHeatMap"]));
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
          dispatch(lenderBoardService.util.invalidateTags([LENDER_BOARD_SERVICE_TAG]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateLenderMutation } = updateLender;

